import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { UNITS } from '@/utils/format-sensor-values'
import { SENSOR_DATA_ROOM } from '@/interfaces/sensordata.interface'
import { collectSensorData, getSensorValueText, getPresence } from '@/utils/format-sensor-values'

interface INFO_DISPLAY_SENSOR_DATA {
  title?: string
  value?: string
}

export default function useReportRoom() {
  const store = useStore()
  const { t } = useI18n()
  const selectedRoom = computed(() => store.state.selectedRoom)
  const sensorDataForSelectedLevel = computed<SENSOR_DATA_ROOM[]>(
    () => store.state.planview.sensorDataForSelectedLevel
  )

  const measurements = computed<INFO_DISPLAY_SENSOR_DATA[]>(() => {
    if (!selectedRoom.value) return []
    const sensordataForSelectedRoom: SENSOR_DATA_ROOM | undefined =
      sensorDataForSelectedLevel.value.find(
        (room) => room.objectId === selectedRoom.value.properties.id
      )
    if (!sensordataForSelectedRoom) return []
    const temperature = collectSensorData(sensordataForSelectedRoom, 'Temperature')
    const co2 = collectSensorData(sensordataForSelectedRoom, 'CO2')
    const presence = getPresence(sensordataForSelectedRoom)
    const humidity = collectSensorData(sensordataForSelectedRoom, 'Humidity')
    const flow = collectSensorData(sensordataForSelectedRoom, 'Flow')
    return [
      {
        title: t('general__data__sensor-temperature'),
        value: getSensorValueText(temperature, 'temperature', UNITS.temperature)
      },
      {
        title: t('general__data__sensor-humidity'),
        value: getSensorValueText(humidity, 'humidity', UNITS.humidity)
      },
      {
        title: t('general__data__sensor-co2'),
        value: getSensorValueText(co2, 'co2', UNITS.co2)
      },
      {
        title: t('general__data__sensor-flow'),
        value: getSensorValueText(flow, 'flow', UNITS.flow)
      },
      {
        title: t('general__data__sensor-presence'),
        value: getSensorValueText(presence, 'presence', UNITS.presence)
      }
    ]
  })

  return {
    measurements
  }
}
